(() => {
  const hydrateSection = (section) => {
    if (section.dataset.hydrated === 'true') return;

    const template = section.querySelector(':scope > template');
    if (!template) return;

    section.dataset.hydrated = 'true';
    const fragment = template.content.cloneNode(true);
    template.replaceWith(fragment);

    section.querySelectorAll('script').forEach((oldScript) => {
      const newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attribute) => {
        newScript.setAttribute(attribute.name, attribute.value);
      });
      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });

    section.querySelector('[data-lazy-app-placeholder]')?.remove();
    section.dispatchEvent(new CustomEvent('lazy-app-section:loaded', { bubbles: true }));
  };

  const initializeLazyAppSections = () => {
    const sections = document.querySelectorAll('[data-lazy-app-section]');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(hydrateSection);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          hydrateSection(entry.target);
        });
      },
      { rootMargin: '1000px 0px' }
    );

    sections.forEach((section) => observer.observe(section));

    if (/review|judge/i.test(window.location.hash)) {
      sections.forEach((section) => {
        observer.unobserve(section);
        hydrateSection(section);
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeLazyAppSections, { once: true });
  } else {
    initializeLazyAppSections();
  }
})();
